import { Link } from "react-router-dom";
import { GitBranch, Rocket, Sparkles, Cloud, Users, ArrowRight } from "lucide-react";
import MicroticaLogo from "../../assets/logo-white.svg";
import HeyReachLogo from "../../assets/heyreach-logo.svg";
import StabenfeldtLogo from "../../assets/stabenfeldt.svg";
import ZoionLogo from "../../assets/zoion-logo.svg";
import VendorLogo from "../../assets/vendor-logo.svg";
import HyphaLogo from "../../assets/hypha.svg";
import LavaLogo from "../../assets/lava.svg";
import VerttLogo from "../../assets/vertt.svg";
import FoundrLogo from "../../assets/foundr.svg";

interface AuthVisualPanelProps {
    showCustomerLogos?: boolean;
}

export default function AuthVisualPanel({ showCustomerLogos = false }: AuthVisualPanelProps) {
    return (
        <div className="login-visual">
            {/* Animated background orbs */}
            <div className="login-visual-bg">
                <div className="login-visual-orb login-visual-orb-1" />
                <div className="login-visual-orb login-visual-orb-2" />
                <div className="login-visual-orb login-visual-orb-3" />
            </div>

            <div className="login-visual-content">
                <Link to="/" className="login-brand">
                    <img src={MicroticaLogo} alt="Microtica" className="login-brand-logo" />
                </Link>
                
                <div className="login-visual-text">
                    <h1 className="login-visual-title">
                        From code to cloud
                        <span className="login-visual-title-accent"> in minutes</span>
                    </h1>
                    <p className="login-visual-subtitle">
                        Push your code and let us handle the rest. Production-ready infrastructure, zero DevOps required.
                    </p>
                </div>

                {/* Visual Journey Flow */}
                <div className="login-journey">
                    <div className="login-journey-step">
                        <div className="login-journey-step-icon">
                            <GitBranch size={22} />
                        </div>
                        <div className="login-journey-step-content">
                            <span className="login-journey-step-title">Connect</span>
                            <span className="login-journey-step-desc">Link your Git repo</span>
                        </div>
                    </div>

                    <div className="login-journey-connector">
                        <ArrowRight size={16} />
                    </div>

                    <div className="login-journey-step">
                        <div className="login-journey-step-icon login-journey-step-icon-active">
                            <Rocket size={22} />
                        </div>
                        <div className="login-journey-step-content">
                            <span className="login-journey-step-title">Push</span>
                            <span className="login-journey-step-desc">Auto build & deploy</span>
                        </div>
                    </div>

                    <div className="login-journey-connector">
                        <ArrowRight size={16} />
                    </div>

                    <div className="login-journey-step">
                        <div className="login-journey-step-icon login-journey-step-icon-success">
                            <Sparkles size={22} />
                        </div>
                        <div className="login-journey-step-content">
                            <span className="login-journey-step-title">Live</span>
                            <span className="login-journey-step-desc">Your app is running</span>
                        </div>
                    </div>
                </div>

                {/* Cloud Account Highlight */}
                <div className="login-cloud-card">
                    <div className="login-cloud-card-icon">
                        <Cloud size={20} />
                    </div>
                    <div className="login-cloud-card-content">
                        <span className="login-cloud-card-title">Your AWS, GCP, or Azure account</span>
                        <span className="login-cloud-card-desc">Full control over your infrastructure. No vendor lock-in.</span>
                    </div>
                </div>

                {/* Customer logos - shown on signup page */}
                {showCustomerLogos && (
                    <div className="signup-social-proof">
                        <div className="signup-social-proof-label">
                            <Users size={14} />
                            <span>Trusted by teams at</span>
                        </div>
                        <div className="signup-logos">
                            <img src={HeyReachLogo} alt="HeyReach" className="logo-heyreach" />
                            <img src={StabenfeldtLogo} alt="Stabenfeldt" className="logo-stabenfeldt" />
                            <img src={ZoionLogo} alt="Zoion" className="logo-zoion" />
                            <img src={VendorLogo} alt="Vendor" className="logo-vendor" />
                            <img src={LavaLogo} alt="Lava" className="logo-lava" />
                            <img src={HyphaLogo} alt="Hypha" className="logo-hypha" />
                            <img src={VerttLogo} alt="Vertt" className="logo-vertt" />
                            <img src={FoundrLogo} alt="Foundr" className="logo-foundr" />
                        </div>
                    </div>
                )}
            </div>

            {/* Grid pattern overlay */}
            <div className="login-visual-grid"></div>
        </div>
    );
}
